import { useEffect, useState } from "react";
import { timeAgo } from "../lib/format";
import { ArrowsClockwise } from "@phosphor-icons/react";

export default function UpdatedAgo({ iso, onClick, testid = "updated-ago-pill" }) {
  const [, force] = useState(0);
  useEffect(() => {
    const id = setInterval(() => force((x) => x + 1), 30000);
    return () => clearInterval(id);
  }, []);

  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-medium transition-all hover:scale-[1.02]"
      style={{
        background: "rgba(255, 184, 28, 0.10)",
        border: "1px solid rgba(255, 184, 28, 0.35)",
        color: "var(--saa-gold)",
      }}
    >
      <ArrowsClockwise size={12} weight="bold" />
      Updated {timeAgo(iso)}
    </button>
  );
}
